export enum BrandDeletionEnum {
    STORES = 'stores',
    CRIS_REQUESTS = 'crisRequests',
    PATTERNS = 'patterns',
    ATTRIBUTES = 'attributes',
    PARTNER_MAP_QUERIES = 'partnerMapQueries',
    PARTNER_MAP_QUERY_MODS = 'partnerMapQueryMods',
}
